import TetheredComponent from './tethered';

export default TetheredComponent;
